import { HeroCarousel } from "@/Sliders/components/HeroCarousel";
import { QuickAccess } from "@/components/QuickAccess";
import { CouponsSection } from "@/components/CouponsSection";
import { StoreLocator } from "@/Locations/components/StoreLocator";
import { useSpotlights } from "@/Spotlights/hooks/use-spotlights";
import { SpotlightCard } from "@/Spotlights/components/SpotlightCard";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useSiteInfo } from "@/SiteInfo/hooks/use-site-info";
import { SEO } from "@/components/SEO";

const Index = () => {
  const { data: spotlights, isLoading: spotlightsLoading } = useSpotlights();
  const { data: siteInfo } = useSiteInfo();
  const hasCoupons = siteInfo?.SiteHasCoupons ?? false;

  // Check if there are any actual spotlight details to display
  const hasSpotlightDetails = spotlights?.some(
    (s) => s.SpotlightDetails && s.SpotlightDetails.length > 0
  ) ?? false;

  return (
    <div className="min-h-screen">
      <SEO
      description="Shop fresh produce, bakery, and quality groceries. Find weekly deals, digital coupons, and store locations near you." />
      <HeroCarousel />
      <QuickAccess />

      {/* Spotlight Items Section - only show when there are actual details */}
      {spotlightsLoading && (
        <section className="py-12 bg-background border-t border-neutral-200">
          <div className="max-w-7xl mx-auto px-4">
            <Skeleton className="h-8 w-48 mb-6" />
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {[1, 2, 3, 4].map((item) => (
                <Card key={item}>
                  <Skeleton className="aspect-square" />
                  <CardContent className="p-4">
                    <Skeleton className="h-8 w-20 mb-2" />
                    <Skeleton className="h-4 w-full" />
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      )}

      {!spotlightsLoading && hasSpotlightDetails && (
        <section className="py-12 bg-background border-t border-neutral-200">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-2xl font-bold text-foreground mb-6">
              Spotlight Items
            </h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {spotlights?.flatMap((spotlight) =>
                spotlight.SpotlightDetails.map((detail, index) => (
                  <SpotlightCard
                    key={`${spotlight.id}-${index}`}
                    spotlight={detail}
                  />
                ))
              )}
            </div>
          </div>
        </section>
      )}

      {hasCoupons && (
        <>
          <CouponsSection
            filterType="Weekly Specials"
            limit={5}
            className="border-t border-neutral-200"
            title="Weekly Specials"
            subtitle="This week's best deals picked just for you"
          />
          <CouponsSection
            limit={5}
            className="border-neutral-200"
            excludeType="Weekly Specials"
            title="Digital Coupons"
            subtitle="Clip coupons and save on your next shopping trip"
          />
        </>
      )}
      <StoreLocator className="border-t border-neutral-200" />
    </div>
  );
};

export default Index;
